export default function generateSummary(demDxSummary) {
  let sb = [];
  const summary = demDxSummary;
  // Presenting Complaint
  sb.push("Presenting Complaint:");
  sb.push(
    `The patient reports "${summary?.presentingComplaint}" for ${summary?.duration} ${summary?.durationUnit}.`
  );
  sb.push("");

  // Medical History
  sb.push("Medical History:");
  sb.push(
    `Positive history: ${summary?.history?.hxOfYes?.join(", ") || "None"}.`
  );
  sb.push(
    `Negative history: ${summary?.history?.hxOfNo?.join(", ") || "None"}.`
  );
  sb.push(
    `Past medical conditions include: ${
      summary?.pastMedicalHistory?.pmhOfYes?.join(", ") || "None"
    }.`
  );
  sb.push(
    `Excluded conditions: ${
      summary?.pastMedicalHistory?.pmhOfNo?.join(", ") || "None"
    }.`
  );
  sb.push("");

  // Medication History
  sb.push("Medication History:");
  sb.push(
    `Current medications: ${summary?.currentMedications?.join(", ") || "None"}.`
  );
  sb.push("");

  // Allergies (Placeholder - adjust if allergy info is available separately)
  sb.push("Allergies:");
  sb.push("No allergy information provided.");
  sb.push("");

  // Family History
  sb.push("Family History:");
  sb.push(
    `Relevant conditions: ${
      summary?.familyHistory?.fhOfYes?.join(", ") || "None"
    }.`
  );
  sb.push(
    `Conditions denied: ${
      summary?.familyHistory?.fhOfNo?.join(", ") || "None"
    }.`
  );
  sb.push("");

  // Social History
  sb.push("Social History:");
  sb.push(`${summary?.socialHistory?.join(", ") || "None"}.`);
  sb.push("");

  // Observations and Assessments
  const v = summary?.vitals || {};
  sb.push("Observations and Assessments:");
  if (v.respRate?.value)
    sb.push(`Respiratory Rate: ${v.respRate?.value} ${v.respRate?.measure}.`);
  if (v.heartRate?.value)
    sb.push(`Heart Rate: ${v.heartRate.value} ${v.heartRate?.measure}.`);
  if (v.tympTemp?.value)
    sb.push(
      `Tympanic Temperature: ${v.tympTemp?.value} ${v.tympTemp?.measure}.`
    );
  if (v.o2Sat?.value)
    sb.push(`Oxygen Saturation: ${v.o2Sat?.value} ${v.o2Sat.measure}.`);
  if (v.bloodPressure?.systolic && v.bloodPressure?.diastolic)
    sb.push(
      `Blood Pressure: ${v.bloodPressure?.systolic}/${v.bloodPressure?.diastolic} ${v.bloodPressure?.measure}.`
    );
  if (v.painScale?.value)
    sb.push(`Pain Scale: ${v.painScale?.value}${v.painScale?.measure}.`);

  sb.push(
    `Physical findings present: ${
      summary?.examination?.exOfYes?.join(", ") || "None"
    }.`
  );
  sb.push(
    `Negative findings: ${summary?.examination?.exOfNo?.join(", ") || "None"}.`
  );
  sb.push("");

  // Management / Advice
  if (summary?.management && summary?.management.length > 0) {
    sb.push("Advice and Counselling Provided:");
    sb.push(summary?.management.join(", "));
    sb.push("");
  }

  // Summary Note / Follow-Up
  if (summary?.summaryNote && summary?.summaryNote.trim()) {
    sb.push("Follow-Up Plan:");
    sb.push(summary?.summaryNote.trim());
  }

  return sb.join("\n");
}
